import Recommendations from './recommendations';

export default Recommendations;
export {
    similarItemsRequestBuilder,
    similarItemsFromShopRequestBuilder,
    similarItemsFromCampaignRequestBuilder
} from './recommendations-requests';
